import PortalIdParser from 'PortalIdParser';
import { ContentObjectTypes } from 'content-management-data-lib';
export const getDetailsUrl = ({
  contentObjectType,
  id
}) => {
  return `/page-details/${PortalIdParser.get()}/${contentObjectType === ContentObjectTypes.LANDING_PAGE ? 'landing' : 'site'}-page/${id}`;
};
export const getEditorUrl = id => `/pages/${PortalIdParser.get()}/editor/${id}`;
export const getListingPageUrl = contentObjectType => `/page-ui/${PortalIdParser.get()}/management/pages/${contentObjectType === ContentObjectTypes.LANDING_PAGE ? 'landing' : 'site'}`;
export const getManagePersonalizationHomeUrl = () => `/personalization/${PortalIdParser.get()}/home/manage`;
export const getManagePersonalizationVariantsUrl = strategyId => {
  if (!strategyId) {
    return getManagePersonalizationHomeUrl();
  }
  return `/personalization/${PortalIdParser.get()}/variants/${strategyId}`;
};